import React, { Component, Fragment } from "react";
import LabelWithInput from "../../../components/molecules/LabelWithInput";
import Button from "../../../components/atoms/Button";
import TextBox from "../../../components/atoms/TextBox";
import TextArea from "../../../components/atoms/TextArea";
import DatePicker from "../../../components/atoms/DatePicker";
import curencyFormat from "../../../utils/helpers/curencyFormat";
import ComboBox from "../../../components/atoms/ComboBox";
import Loading from "../../../components/molecules/Loading";
import dateFormatIndo from "../../../utils/helpers/dateFormatIndo";

class DataPinjamanNew extends Component {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.state = {
			listLoanPurpose: [
				{ value: 1, text: "Pembelian Stok" },
				{ value: 2, text: "Pembelian Mesin" },
				{ value: 3, text: "Pengembangan Bisnis" },
				{ value: 4, text: "Kebutuhan Arus Kas" },
			],
			loanDetail: {
				loanPurpose: 0,
				otherLoanAmount: "",
			},
			collateralDetail: {
				payorName: "",
				invoiceIssueDate: "",
				invoiceDueDate: "",
				invoiceAmount: "",
			},
		};
	}

	componentDidMount = () => {
		this._isMounted = true;
		this.props.ResetStatusState();
	};

	componentWillUnmount = () => {
		this._isMounted = false;
	};

	componentDidUpdate = (prevProps) => {
		if (this.props.detailPinjaman.detail !== prevProps.detailPinjaman.detail) {
			if (this.props.detailPinjaman.detail !== null) {
				const { detail } = this.props.detailPinjaman;
				const { payorName, invoiceNumber, invoiceIssueDate, invoiceDueDate, invoiceAmount } = detail.collateralDetail;

				const idLoanPurpose = detail.loanPurpose ? (this.getLoanPurpose(detail.loanPurpose, true) ? this.getLoanPurpose(detail.loanPurpose, true).value : 0) : 0;
				if (this._isMounted) {
					this.setState({
						loanDetail: {
							otherLoanAmount: detail.otherLoanAmount ? (detail.otherLoanAmount > 0 ? String(Number(detail.otherLoanAmount)) : "") : "",
							loanPurpose: idLoanPurpose,
						},
						collateralDetail: {
							payorName: payorName ? payorName : "",
							invoiceIssueDate: invoiceIssueDate ? new Date(invoiceIssueDate) : "",
							invoiceDueDate: invoiceDueDate ? new Date(invoiceDueDate) : "",
							invoiceAmount: invoiceAmount ? (invoiceAmount > 0 ? String(Number(invoiceAmount)) : "") : "",
						},
					});
				}
			}
		}
	};

	onChangeHandler = (parent, { name, value }) => {
		value = name === "invoiceAmount" || name === "otherLoanAmount" ? value.replace(/\D/g, "") : value;
		if (this._isMounted) {
			this.setState({
				[parent]: {
					...this.state[parent],
					[name]: value,
				},
			});
		}
	};

	getLoanPurpose = (id, isName = false) => {
		return this.state.listLoanPurpose.find((x) => (isName ? x.text == id : x.value == id));
	};

	checkNull = (value) => {
		if (value == "" || value == 0 || value == undefined || value == null) {
			return true;
		} else {
			return false;
		}
	};

	onSubmitStep = () => {
		const { loanCode } = this.props.match.params;
		const { SetError, postOrPatch } = this.props;
		const { collateralDetail, loanDetail } = this.state;
		let dataSubmit = {
			productUID: "KC.P001.000001",
			collateralType: "INVOICE",
			collateralDetail: {
				invoiceNumber: "KC-00001",
				...collateralDetail,
			},
			loanDetail: { ...loanDetail },
		};

		if (this.checkNull(loanDetail.loanPurpose)) {
			delete dataSubmit.loanDetail.loanPurpose;
		} else {
			dataSubmit.loanDetail.loanPurpose = this.getLoanPurpose(loanDetail.loanPurpose).text;
		}
		this.checkNull(loanDetail.otherLoanAmount) && delete dataSubmit.loanDetail.otherLoanAmount;

		this.checkNull(collateralDetail.payorName) && delete dataSubmit.collateralDetail.payorName;

		if (this.checkNull(collateralDetail.invoiceDueDate)) {
			delete dataSubmit.collateralDetail.invoiceDueDate;
		} else {
			dataSubmit.collateralDetail.invoiceDueDate = dateFormatIndo(collateralDetail.invoiceDueDate, "db");
		}

		if (this.checkNull(collateralDetail.invoiceIssueDate)) {
			delete dataSubmit.collateralDetail.invoiceIssueDate;
		} else {
			dataSubmit.collateralDetail.invoiceIssueDate = dateFormatIndo(collateralDetail.invoiceIssueDate, "db");
		}

		if (!this.checkNull(collateralDetail.invoiceAmount)) {
			postOrPatch({
				data: dataSubmit,
				stepChange: 1,
				loanCode: loanCode ? loanCode : null,
			});
		} else {
			SetError("Nilai Pengajuan Pinjaman tidak boleh kosong");
		}
	};

	render() {
		const { col, status, detailPinjaman } = this.props;
		const { payorName, invoiceIssueDate, invoiceDueDate, invoiceAmount } = this.state.collateralDetail;
		const { loanPurpose, otherLoanAmount } = this.state.loanDetail;
		return (
			<Fragment>
				<Loading display={detailPinjaman.loading} />
				<LabelWithInput label="Tujuan Pinjaman" col={col} {...this.props}>
					<ComboBox
						onChange={({ target }) => {
							this.onChangeHandler("loanDetail", target);
						}}
						title="Tujuan Pinjaman"
						data={this.state.listLoanPurpose}
						value={loanPurpose}
						name="loanPurpose"
					/>
				</LabelWithInput>
				<LabelWithInput label="Rincian Penggunaan Dana" col={col} {...this.props}>
					<TextArea
						onChange={({ target }) => {
							this.onChangeHandler("collateralDetail", target);
						}}
						value={payorName}
						opts={{ maxLength: 200 }}
						name="payorName"
					/>
				</LabelWithInput>
				<LabelWithInput label="Nilai Pengajuan Pinjaman" col={col} {...this.props}>
					<TextBox
						onChange={({ target }) => {
							this.onChangeHandler("collateralDetail", target);
						}}
						value={invoiceAmount ? curencyFormat(invoiceAmount) : ""}
						name="invoiceAmount"
					/>
				</LabelWithInput>
				<LabelWithInput label="Tgl. Rencana Kebutuhan Dana" col={col} {...this.props}>
					<DatePicker
						onChange={(target) => {
							this.onChangeHandler("collateralDetail", target);
						}}
						value={invoiceIssueDate}
						name="invoiceIssueDate"
					/>
				</LabelWithInput>
				<LabelWithInput label="Tgl. Rencana Pengembalian" col={col} {...this.props}>
					<DatePicker
						onChange={(target) => {
							this.onChangeHandler("collateralDetail", target);
						}}
						value={invoiceDueDate}
						name="invoiceDueDate"
					/>
				</LabelWithInput>
				<LabelWithInput label="Total nilai pinjaman selain di KlikCair?" col={col} {...this.props}>
					<TextBox
						onChange={({ target }) => {
							this.onChangeHandler("loanDetail", target);
						}}
						value={otherLoanAmount ? curencyFormat(otherLoanAmount) : ""}
						name="otherLoanAmount"
					/>
				</LabelWithInput>

				<div className="bg-button flex-column align-items-start">
					<Button title="Selanjutnya" color="blue" width="big" loading={status.loading} onClick={() => this.onSubmitStep()} />
					<small className="mt-2 text-muted font-italic">* Tombol Selanjutnya akan otomatis membuat draf pinjaman baru</small>
				</div>
			</Fragment>
		);
	}
}

export default DataPinjamanNew;
